/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelHubtranControl.ts                *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/dispatch/hubtran-control";

export class AutogenModelHubtranControl<RowType extends ModelRow> extends Endpoint<RowType, RowHubtranControlFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowHubtranControl extends ModelRow<RowHubtranControlFields> {
	constructor(values?: Partial<RowHubtranControlFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowHubtranControlFields {
	api_token: string;
	api_url: string;
	company_id: string;
	exception_handling: string;
	id: number;
	include_service_incidents: string;
	is_active: string;
	lastrun: Date;
	log_level: number;
	max_log_file_size: number;
	oktopay_override: string;
	rdy_bill_noninv_doc_types: string;
	ready_to_bill: string;
	ready_to_pay: string;
	run_interval: number;
	send_comment_types: string;
	send_order_hist_types: string;
}

